import roles from "../../utils/roles";
import { authorizationActions } from "../actions/authorization";
import jwtDecode from "jwt-decode";

const initialState = () => ({
  isFetching: false,
  isRestoringSession: false,
  id: undefined,
  roles: undefined,
  phone: undefined,
  client: undefined,
  showPaymentAuthorizedModal: false,
});

export default (state = initialState(), { type, payload }) => {
  switch (type) {
    case authorizationActions.setPhoneNumber:
      return {
        ...state,
        phone: payload.phone,
      };
    case authorizationActions.setUserToken:
      return {
        ...state,
        ...jwtDecode(payload.token),
        roles: [ roles.authorized ],
      };
    case authorizationActions.setClient:
      return {
        ...state,
        client: payload.client,
      };
    case authorizationActions.updateClient:
      return {
        ...state,
        client: {
          ...state.client,
          firstName: payload.firstName,
          lastName: payload.lastName,
          email: payload.email,
        },
      };
    case authorizationActions.handlePaymentAuthorizedModal:
      return {
        ...state,
        showPaymentAuthorizedModal: !state.showPaymentAuthorizedModal,
      };
    case authorizationActions.setTerms:
      return {
        ...state,
        client: {
          ...state.client,
          registration: {
            ...state.client.registration,
            termAndPolicyAgreed: payload.termAndPolicyAgreed
          }
        },
      };
    case authorizationActions.logout:
      return {
        ...initialState()
      };
    case authorizationActions.changeFetchingStatus:
      return {
        ...state,
        isFetching: payload.isFetching,
      };
    case authorizationActions.changeIsRestoringSession:
      return {
        ...state,
        isRestoringSession: payload.isRestoringSession,
      };

    default:
      return state;
  }
}
